import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { NavigationItem } from "types/navigation"

export default function LinkList({
  items,
  title,
}: {
  items: NavigationItem[]
  title?: string
}) {
  return (
    <div>
      {title && (
        <h3 className="text-[13px] font-bold text-brand-navy uppercase tracking-wide mb-2 pb-1 border-b border-gray-200">
          {title}
        </h3>
      )}
      <ul className="space-y-0">
        {items.map((item) => (
          <li key={item.id}>
            <LocalizedClientLink
              href={item.url}
              className={`text-[13px] leading-tight block py-1.5 transition-colors ${
                item.highlight
                  ? "text-brand-accent font-bold hover:text-red-700"
                  : "text-gray-700 hover:text-brand-primary font-medium"
              }`}
            >
              {item.label}
            </LocalizedClientLink>
          </li>
        ))}
      </ul>
    </div>
  )
}
